import { render, staticRenderFns } from "./Specifications.vue?vue&type=template&id=613c7b6b&"
import script from "./Specifications.vue?vue&type=script&lang=js&"
export * from "./Specifications.vue?vue&type=script&lang=js&"
import style0 from "./Specifications.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Specifications.vue"
export default component.exports